"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemData = void 0;
const os_1 = __importDefault(require("os"));
function getSystemData() {
    const interfaces = os_1.default.networkInterfaces();
    const hostname = os_1.default.hostname();
    let ipv4;
    let ipv6;
    Object.values(os_1.default.networkInterfaces()).forEach(inter => {
        inter.forEach(({ family, internal, address }) => {
            if (family === 'IPv4' && internal === false)
                ipv4 = address;
            if (family === 'IPv6' && internal === false)
                ipv6 = address;
        });
    });
    return {
        ipv4,
        ipv6,
        hostname
    };
}
exports.getSystemData = getSystemData;
//# sourceMappingURL=system-data.js.map